
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState } from 'react';
import Head from 'next/head';
import MainLayout from '../../components/layout/MainLayout';
import Navigation from '../../components/layout/Navigation';
import DocsSidebar from '../../components/Docs/DocsSidebar';
import DocsContent from '../../components/Docs/DocsContent';
import DocsToc from '../../components/Docs/DocsToc';
import useTranslation from 'next-translate/useTranslation';
export default function DocsIndex() {
    const { t } = useTranslation();
    const seo = t('common:seo', {}, { returnObjects: true });
    const docs = t('docs:sections', {}, { returnObjects: true }) || [];
    const [sidebarOpen, setSidebarOpen] = useState(false);
    // Find current section (index page = first section with empty slug)
    const sections = Array.isArray(docs) ? docs : [];
    const currentSection = sections.find((s) => s.slug === '') || sections[0] || { title: 'Documentation', content: '' };
    const currentIndex = sections.findIndex((s) => s.slug === '');
    const prevSection = currentIndex > 0 ? sections[currentIndex - 1] : null;
    const nextSection = currentIndex < sections.length - 1 ? sections[currentIndex + 1] : null;
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "TechArticle",
        "headline": currentSection.title,
        "description": currentSection.description || seo.docs?.description,
        "author": {
            "@type": "Organization",
            "name": "HFDX"
        },
        "publisher": {
            "@type": "Organization",
            "name": "HFDX",
            "logo": {
                "@type": "ImageObject",
                "url": "https://hfdx.xyz/logo.png"
            }
        },
        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "https://hfdx.xyz/docs"
        }
    };
    return (<MainLayout loaded={true} title={`${currentSection?.title || 'Documentation'} | HFDX Docs`} description={currentSection.description || seo.docs?.description} keywords={seo.docs?.keywords} page="docs_page" alternate="docs" canonical="/docs" schemaData={schemaData}>
            <Head>
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css" integrity="sha384-n8MVd4RsNIU0tAv4ct0nTaAbDJwPJzDEaqSD1odI+WdtXRGWt2kTvGFasHpSy3SV" crossOrigin="anonymous"/>
            </Head>

            <Navigation variant="light"/>

            <div className="docs_layout">
                <DocsSidebar sections={sections} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}/>

                <main className="docs_main">
                    <div className="docs_content_wrapper">
                        <DocsContent section={currentSection} prevSection={prevSection} nextSection={nextSection}/>
                        <DocsToc content={currentSection?.content || ''}/>
                    </div>
                </main>

                <button className="docs_mobile_toggle" onClick={() => setSidebarOpen(true)} aria-label="Open navigation">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </button>
            </div>
        </MainLayout>);
}
function getStaticProps() {
    return {
        props: {}
    };
}

    async function __Next_Translate__getStaticProps__1a17ab3f2a9__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/docs/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f2a9__ as getStaticProps }
  